import { useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const useCreateQueryItem = () => {
  const queryClient = useQueryClient()
  const { notification } = App.useApp()
  const { t } = useTranslation()

  const createQueryItem = useMemo(
    () => (options: { queryKey: string[] | readonly unknown[] }[]) => {
      options.forEach(o => queryClient.invalidateQueries({ queryKey: o.queryKey }))
      notification.success({ message: t('messages:createSuccess', 'Success') })
    },
    [queryClient, notification, t]
  )

  return createQueryItem
}

export default useCreateQueryItem
